<template>
  <span class="ai-publish-miniapp">
    <Button
      type="success"
      icon="md-cloud-upload"
      :disabled="disabled"
      :loading="loading"
      @click="openModal"
    >发布</Button>
    <Modal
      v-model="visible"
      title="发布为个人应用"
      :loading="loading"
      ok-text="发布"
      @on-ok="handlePublish"
      @on-cancel="closeModal"
    >
      <Form ref="formRef" :model="form" :rules="rules" :label-width="100">
        <FormItem label="发布名称" prop="name">
          <Input v-model="form.name" placeholder="应用显示名称" />
        </FormItem>
        <FormItem label="应用 ID" prop="id">
          <Input v-model="form.id" placeholder="可选，自定义访问 ID / key" />
          <p class="ai-publish-hint">留空则由系统自动生成；填写后可通过 /public/miniapps/{id} 访问</p>
        </FormItem>
        <FormItem label="描述" prop="description">
          <Input v-model="form.description" type="textarea" :rows="2" placeholder="可选" />
        </FormItem>
        <FormItem label="需登录" prop="private">
          <i-switch v-model="form.private" :true-value="false" :false-value="true">
            <span slot="open">是</span>
            <span slot="close">否</span>
          </i-switch>
          <span class="ai-publish-hint inline">否 = 仅自己可见，是 = 所有人可见</span>
        </FormItem>
      </Form>
    </Modal>
  </span>
</template>

<script>
import { isCompleteHtmlDocument } from '@/components/ai/is-complete-html';

const API_BASE = '/ai/miniapps';

export default {
  name: 'AiPublishMiniappButton',
  props: {
    content: {
      type: String,
      default: '',
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    defaultName: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      visible: false,
      loading: false,
      form: {
        name: '',
        id: '',
        description: '',
        private: true,
      },
      rules: {
        name: [{ required: true, message: '请输入发布名称', trigger: 'blur' }],
      },
    };
  },
  methods: {
    openModal() {
      if (this.disabled) return;
      const html = String(this.content || '').trim();
      if (!isCompleteHtmlDocument(html)) {
        this.$Message.warning('仅完整 HTML 页面可发布为应用');
        return;
      }
      this.form.name = (this.defaultName && String(this.defaultName).trim()) || 'AI 报告页面';
      this.form.id = '';
      this.form.description = '';
      this.form.private = true;
      this.visible = true;
    },
    closeModal() {
      this.visible = false;
    },
    async handlePublish() {
      const html = String(this.content || '').trim();
      if (!isCompleteHtmlDocument(html)) {
        this.$Message.warning('仅完整 HTML 页面可发布为应用');
        return false;
      }
      try {
        const valid = await this.$refs.formRef.validate();
        if (!valid) return false;
      } catch (e) {
        return false;
      }

      const payload = {
        name: String(this.form.name || '').trim(),
        description: String(this.form.description || '').trim() || undefined,
        private: this.form.private,
        content: html,
      };
      const customId = String(this.form.id || '').trim();
      if (customId) {
        payload.id = customId;
        payload.key = customId;
      }

      this.loading = true;
      try {
        const res = await this.$api.post(API_BASE, payload);
        const data = (res && res.data && res.data.data) || (res && res.data) || {};
        this.$Message.success('发布成功');
        this.closeModal();
        this.$emit('published', data);
        if (data && data.id) {
          this.$Modal.confirm({
            title: '发布成功',
            content: `应用「${payload.name}」已创建。是否在新窗口打开？`,
            okText: '打开',
            cancelText: '关闭',
            onOk: () => {
              this.openPublishedApp(data);
            },
          });
        }
      } catch (err) {
        console.error(err);
        this.$Message.error((err && err.message) || '发布失败');
        return false;
      } finally {
        this.loading = false;
      }
      return true;
    },
    openPublishedApp(item) {
      if (!item || !item.id) return;
      const base = (this.$api.defaults.baseURL || '').replace(/\/$/, '');
      const session = this.$store.getters['session/session'] || {};
      let url = `${base}/public/miniapps/${encodeURIComponent(item.id)}`;
      if (item.private && session.token) {
        url += `?authkey=${String(session.token).replace(/^Bearer\s+/i, '')}`;
      }
      window.open(url, '_blank');
    },
  },
};
</script>

<style lang="less" scoped>
.ai-publish-hint {
  margin: 4px 0 0;
  font-size: 12px;
  color: var(--subtext2);
  line-height: 1.4;
}
.ai-publish-hint.inline {
  margin-left: 8px;
}
</style>
